import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BackendService,
  HttpOptions,
  PaginatedResponseModel,
} from '@ipg/ngx-frontend-toolset';
import { NotificationLog } from '../notification-logs.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationLogsService {
  private readonly _backend = inject(BackendService);

  getAll(options?: HttpOptions): Observable<PaginatedResponseModel<NotificationLog[]>> {
    return this._backend.get('/notification-logs', options);
  }
}
